"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getUrl = getUrl;
var _axios = require("@ori/axios");
var _checkoutUtils = require("@ori/checkout-utils");
var _constants = require("../constants");
async function getUrl({
  basePath: originalBasePath,
  currentLanguage,
  host: originalHost,
  isAddingSpecialHeadersForbidden,
  isAuthorizationRequired,
  method: originalMethod,
  query,
  tenant,
  formattedToken,
  ...config
}) {
  let isMockup = false;
  if (process.env.NODE_ENV !== 'production') {
    isMockup = (0, _checkoutUtils.isDataMockup)(_constants.APP_NAME);
  }
  let method = originalMethod;
  const basePath = (0, _checkoutUtils.normalizeSlashChars)(originalBasePath, true, false);
  const host = (0, _checkoutUtils.normalizeSlashChars)(originalHost, undefined, false);
  let url = `${host}${basePath}${query ?? ''}`;
  if (isMockup) {
    method = _checkoutUtils.HttpMethod.Get;
    url = `/mockups${basePath}.json`;
  }
  const addTokenToHeader = !isMockup && isAuthorizationRequired;
  const headers = {
    ...config.headers,
    ...(addTokenToHeader && {
      Authorization: formattedToken
    }),
    ...(0, _checkoutUtils.getHeaders)({
      currentLanguage,
      isAddingSpecialHeadersForbidden,
      tenant
    }, _constants.APP_NAME)
  };
  const {
    data
  } = await _axios.axios.request({
    ...config,
    headers,
    method,
    url
  });
  return data;
}